export default "__VITE_ASSET__007e317d__"